<div class="mb-2">
  <div class="font-bold mb-1" style="font-size: 20px">Request Transfer to {{ data.regionName }}</div>
  <div class="text-sm text-gray-600 mb-3" style="width: 500px">
    Your transfer will be reviewed by the 5F team. You will receive an email within 24 hours regarding the status of
    your request.
  </div>
  <mat-dialog-content class="h-35">
    <div class="flex flex-col" [formGroup]="requestForm">
      <ng-container
        formArrayName="requests"
        *ngFor="let request of requestsArray.controls; index as i; trackBy: null | trackByKey"
      >
        <div [formGroupName]="i">
          <div class="flex flex-row gap-x-2 items-center">
            <mat-form-field appearance="outline">
              <mat-label>Driver</mat-label>
              <mat-select formControlName="driver">
                <mat-option>
                  <ngx-mat-select-search
                    placeholderLabel="Search"
                    [formControl]="driverSearch"
                    noEntriesFoundLabel="No Driver Found"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let driver of drivers$ | async; trackBy: 'driverId' | trackByKey" [value]="driver">
                  {{ driver.driverName }}
                  <ng-container *ngIf="driver.regionName">({{ driver.regionName }})</ng-container>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Transfer Date</mat-label>
              <input
                [min]="today"
                matInput
                [matDatepicker]="transferDatePicker"
                formControlName="transferDate"
                readonly
                (click)="transferDatePicker.open()"
              />
              <mat-datepicker-toggle matSuffix [for]="transferDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #transferDatePicker></mat-datepicker>
            </mat-form-field>
            <div class="pb-2">
              <button
                mat-icon-button
                class="text-red-500 cursor-pointer"
                *ngIf="requestsArray.length > 1"
                (click)="removeRequest(i)"
              >
                <mat-icon>do_not_disturb_on</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="flex items-center text-lg text-gray-600 cursor-pointer" (click)="addNewRequest()">
        <mat-icon class="mr-1">add_circle_outline</mat-icon>
        Transfer Another Driver
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      type="submit"
      mat-button
      class="submit-button bg-blue-500 text-white"
      style="position: relative; height: 40px; width: 150px"
      [disabled]="loading$$ | async"
      (click)="sendRequest()"
    >
      <div class="flex justify-center">
        <ng-container *ngIf="(loading$$ | async) === false">Submit Request</ng-container>
        <mat-spinner *ngIf="(loading$$ | async) === true" [diameter]="30"></mat-spinner>
      </div>
    </button>
  </mat-dialog-actions>
  <ng-template #loader>
    <mat-spinner [diameter]="40" class="m-auto"></mat-spinner>
  </ng-template>
</div>
